export default "<p>\n    Shape works!\n</p>>"